var _g, _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1081,
    height: 1160,
    viewBox: "0 0 1081 1160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_5_18)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 540.5,
    cy: 580,
    rx: 500.5,
    ry: 540,
    fill: "url(#paint0_radial_5_18)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M655.577 574.209C684.545 523.681 690.232 474.873 665.233 450.005C640.233 425.138 591.557 430.694 541.029 459.661C562.854 472.227 584.943 489.026 605.578 509.66C626.212 530.295 643.011 552.384 655.577 574.209Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M426.481 574.209C397.513 624.737 391.825 673.546 416.825 698.413C441.692 723.28 490.501 717.725 541.029 688.757C519.204 676.191 497.115 659.393 476.48 638.758C455.845 618.124 439.047 596.034 426.481 574.209Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M541.029 459.661C490.501 430.693 441.692 425.006 416.825 450.005C391.958 475.005 397.513 523.681 426.481 574.209C439.047 552.384 455.846 530.295 476.48 509.66C497.115 489.026 519.204 472.227 541.029 459.661Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M605.578 638.758C584.943 659.393 562.854 676.191 541.029 688.757C591.557 717.725 640.366 723.413 665.233 698.413C690.1 673.414 684.545 624.737 655.577 574.209C643.011 596.034 626.212 618.124 605.578 638.758Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M541.029 630.557C572.223 630.557 597.509 605.27 597.509 574.076C597.509 542.883 572.223 517.596 541.029 517.596C509.836 517.596 484.549 542.883 484.549 574.076C484.549 605.27 509.836 630.557 541.029 630.557Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_5_18",
    x: 0,
    y: 0,
    width: 1081,
    height: 1160,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20,
    result: "effect1_foregroundBlur_5_18"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_5_18",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(526.891 535.952) rotate(-113.557) scale(781.899 701.143)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B3B3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.874736c8008d39b58e593a0378070a2a.svg";
export { ForwardRef as ReactComponent };